import { IconButton, styled } from '@mui/material';
import { MAIN_THEME_COLOR } from '../../../assets/theme/Colors';

const FacebookActionIconButton = styled(IconButton)(() => ({
	color: MAIN_THEME_COLOR,
	height: '32px',
	padding: '6px',
	width: '32px',
	'&:hover': {
		backgroundColor: '#EBFAF8',
	},
}));

export default FacebookActionIconButton;
